<template>
  <svg width="184"
       height="10"
       viewBox="0 0 184 10"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M181.793 4.50014H0.5C0.367392 4.50014 0.240214 4.55282 0.146446 4.64659C0.052678 4.74036 0 4.86753 0 5.00014C0 5.13275 0.052678 5.25993 0.146446 5.3537C0.240214 5.44746 0.367392 5.50014 0.5 5.50014H181.793L178.146 9.14614C178.052 9.24003 177.999 9.36737 177.999 9.50014C177.999 9.63292 178.052 9.76026 178.146 9.85414C178.24 9.94803 178.367 10.0008 178.5 10.0008C178.633 10.0008 178.76 9.94803 178.854 9.85414L183.354 5.35414C183.401 5.3077 183.438 5.25252 183.463 5.19178C183.488 5.13103 183.501 5.06591 183.501 5.00014C183.501 4.93438 183.488 4.86926 183.463 4.80851C183.438 4.74776 183.401 4.69259 183.354 4.64614L178.854 0.146143C178.76 0.0522566 178.633 -0.000488281 178.5 -0.000488281C178.367 -0.000488281 178.24 0.0522566 178.146 0.146143C178.052 0.24003 177.999 0.367368 177.999 0.500143C177.999 0.632919 178.052 0.760257 178.146 0.854143L181.793 4.50014Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#46545C"
    }
  }
}
</script>
